module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12\">\r\n            <h1>")
    ; __append(escapeFn( 'List Details - ' + currentListDetails.Name ))
    ; __append("</h1>\r\n        </div>\r\n    </div>\r\n\r\n    <ol class=\"breadcrumb\">\r\n        ")
    ; 
        var count = breadcrumbs.length;
        var crumbCount = 0;
        _.forEach(breadcrumbs, function (crumb) {
            crumbCount++;
            if (crumbCount === count) {
            
    ; __append("\r\n                <li><span>")
    ; __append(escapeFn( crumb.name ))
    ; __append("</span></li>\r\n            ")
    ;  } else { 
    ; __append("\r\n                <li><a href=\"")
    ; __append(escapeFn( crumb.route ))
    ; __append("\" id=\"")
    ; __append(escapeFn( crumb.id ))
    ; __append("\">")
    ; __append(escapeFn( crumb.name ))
    ; __append("</a></li>\r\n            ")
    ; 
            }
        }); 
    ; __append("\r\n    </ol>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"row\">\r\n        <h2>General</h2>\r\n    </div>\r\n        <div class=\"row nopadding-l\">\r\n                <div class=\"col-md-2\"><label>Name</label></div>\r\n                <div class=\"col-md-4\"><input type=\"text\" name=\"Name\" value=\"")
    ; __append(escapeFn( currentListDetails.Name ))
    ; __append("\" /></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-2\"><label>Date Created</label></div>\r\n            <div class=\"col-md-10\"><label>")
    ; __append(escapeFn( currentListDetails.CreateDate))
    ; __append("</label></div>\r\n        </div>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-2\"><label>Last Update</label></div>\r\n            <div class=\"col-md-10\"><label>")
    ; __append(escapeFn( currentListDetails.LastUpdateDate))
    ; __append("</label></div>\r\n        </div>\r\n    \r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h2>List</h2>\r\n        <div class=\"row nopadding\">\r\n        <table id=\"propMainTable\"></table>\r\n    </div>\r\n     </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-7\">\r\n        <button class=\"btn btn-default hvr-glow tbl-icon itemNew\" title=\"Add\"><i class=\"fa pf-add\"></i></button>\r\n        <button class=\"btn btn-default hvr-glow tbl-icon itemRemove\" title=\"Remove\"><i class=\"fa pf-delete icon-gradient\"></i></button>\r\n        <button class=\"btn btn-default hvr-glow tbl-icon itemUp\" title=\"Move Down\"><i class=\"fa pf-icon-up pf-carot-down\" style=\"-webkit-transform: rotate(-180deg);\"></i></button>\r\n        <button class=\"btn btn-default hvr-glow tbl-icon itemDown\" title=\"Move Up\"><i class=\"fa pf-carot-down\" aria-expanded=\"true\"></i></button>\r\n        <button class=\"btn btn-default hvr-glow\" name='quickPaste' style=\"width: 110px;padding: 3px;margin-top: 2px;\" title=\"Quick Paste\">Quick Paste</button>\r\n    </div>\r\n    <div class=\"col-md-1 col-md-offset-4\">\r\n\r\n    </div>\r\n</div>\r\n\r\n<div id=\"actionsSection\" class=\"actionButtons row ")
    ; __append(escapeFn( hasChanges ? 'hide' : '' ))
    ; __append("\">\r\n    <div class=\"col-md-6\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"import\" value=\"Import\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"delete\" value=\"Delete\">\r\n    </div>\r\n</div>\r\n<div id=\"changesSection\" class=\"actionButtons row ")
    ; __append(escapeFn( hasChanges ? '' : 'hide' ))
    ; __append("\">\r\n    <div class=\"col-md-6\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"applyChanges\" value=\"Apply Changes\"/>\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"cancelChanges\" value=\"Cancel\">\r\n    </div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n        <h2>Settings Help</h2>\r\n        <div class=\"row nopadding-l\">\r\n            <div class=\"col-md-12 nopadding-l\"><a href=\"")
    ; __append(escapeFn(constants.HELP_ADD_LIST ))
    ; __append("\" target=\"_blank\">Adding a list</a></div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n")
  }
  return __output;

}